import React from "react";
import Icon from "../../../components/AppIcon";

const HeroSection = () => {
  return (
    <section className="relative text-whiten pt-32 pb-20 px-4 md:px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 ">
     <div
    className="absolute inset-0 bg-cover bg-center"
    style={{ backgroundImage: "url('/hero_section/About.png')" }}
  />
        
        <div className="absolute top-20 left-10 w-64 h-64 "></div>
        <div className="absolute bottom-20 right-10 w-96 h-96"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="Award" size={20} color="#ffffff" />
            <span className="text-white text-sm font-medium">
              13+ Years of Excellence
            </span>
          </div>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
            Where IT Meets Branding
            <br />
            In One Company
          </h1>

          <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-3xl mx-auto mb-8">
            Orator Hype embodies the convergence of technical excellence and
            creative vision. We're not just a service provider—we're your
            trusted partner in digital transformation, understanding both the
            technical complexities of modern IT infrastructure and the nuanced
            art of brand building.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 min-w-[140px] md:min-w-[160px]">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Icon name="Users" size={24} color="#ffffff" />
                <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
                  196+
                </span>
              </div>
              <p className="text-white/90 text-xs md:text-sm">Happy Clients</p>
            </div>

            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 min-w-[140px] md:min-w-[160px]">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Icon name="Briefcase" size={24} color="#ffffff" />
                <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
                  223+
                </span>
              </div>
              <p className="text-white/90 text-xs md:text-sm">
                Projects Delivered
              </p>
            </div>

            <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 md:p-6 min-w-[140px] md:min-w-[160px]">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Icon name="Calendar" size={24} color="#ffffff" />
                <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-white">
                  13K+
                </span>
              </div>
              <p className="text-white/90 text-xs md:text-sm">
                Client Meetings
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
